import apiClient, { formatApiError } from "./client";

/**
 * Password Manager Security API Service
 * Maps to: PasswortManagerSecurityController (/api/passwort-manager)
 * Handles Sicherheit & Zugriff (Page 1) operations
 */

export const getSecurityState = async (oid) => {
  try {
    const response = await apiClient.get(`/api/passwort-manager/${oid}/security-page`);
    return response.data;
  } catch (error) {
    console.error("getSecurityState error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Laden des Sicherheitsstatus") };
  }
};

export const getUnlockMaterial = async (oid) => {
  try {
    const response = await apiClient.get(`/api/passwort-manager/${oid}/unlock-material`);
    return response.data;
  } catch (error) {
    console.error("getUnlockMaterial error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Laden der Entsperrdaten") };
  }
};

export const setupUserKey = async (oid, request) => {
  try {
    const response = await apiClient.post(`/api/passwort-manager/${oid}/user-key/setup`, request);
    return response.data;
  } catch (error) {
    console.error("setupUserKey error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Einrichten des Benutzer-Schlüssels") };
  }
};

export const rotateUserKey = async (oid, request) => {
  try {
    const response = await apiClient.put(`/api/passwort-manager/${oid}/user-key/rotate`, request);
    return response.data;
  } catch (error) {
    console.error("rotateUserKey error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Ändern des Benutzer-Schlüssels") };
  }
};

export const resetPasswordManager = async (oid) => {
  try {
    const response = await apiClient.post(`/api/passwort-manager/${oid}/reset`);
    return response.data;
  } catch (error) {
    console.error("resetPasswordManager error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Zurücksetzen des Passwort-Managers") };
  }
};
